import script from "./payee_entry.vue?vue&type=script&setup=true&lang=ts"
export * from "./payee_entry.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__